import { Route, Routes } from 'react-router-dom';
import DashboardLayout from '@/layouts/dashboard';
import AuthGuard from '@/guards/AuthGuard';
import RoleBasedGuard from '@/guards/RoleBasedGuard';

import { PATH_SERVICES_MANAGEMENT } from './paths';
import {
  BlockedDatesList,
  ServiceCreateEdit,
  ServiceVariantCreateEdit,
  ServicesList,
  ServiceVariantsList,
} from '../pages';

const SERVICE_MANAGEMENT_ROUTES = [
  {
    path: PATH_SERVICES_MANAGEMENT.services,
    roles: ['services.view'],
    component: <ServicesList />,
    index: false,
  },
  {
    path: PATH_SERVICES_MANAGEMENT.variants,
    roles: ['services.view'],
    component: <ServiceVariantsList />,
    index: false,
  },
  {
    path: PATH_SERVICES_MANAGEMENT.blockedDates,
    roles: ['services.view'],
    component: <BlockedDatesList />,
    index: false,
  },
  {
    path: PATH_SERVICES_MANAGEMENT.newService,
    roles: ['services.create'],
    component: <ServiceCreateEdit />,
    index: false,
  },
  {
    path: PATH_SERVICES_MANAGEMENT.newVariant,
    roles: ['services.create'],
    component: <ServiceVariantCreateEdit />,
    index: false,
  },
  {
    path: PATH_SERVICES_MANAGEMENT.editService,
    roles: ['services.update'],
    component: <ServiceCreateEdit />,
    index: false,
  },
  {
    path: PATH_SERVICES_MANAGEMENT.editVariant,
    roles: ['services.update'],
    component: <ServiceVariantCreateEdit />,
    index: false,
  },
];

export const ServicesManagementRoutes = () => (
  <Routes>
    <Route
      element={
        <AuthGuard>
          <DashboardLayout />
        </AuthGuard>
      }
    >
      {SERVICE_MANAGEMENT_ROUTES.map((route, index) => (
        <Route
          key={index}
          path={route.path}
          index={route.index}
          element={
            <RoleBasedGuard roles={route.roles}>
              {route.component}
            </RoleBasedGuard>
          }
        />
      ))}
    </Route>
  </Routes>
);
